import React from 'react'
import 'rc-steps/assets/index.css'

import { SearchProject } from '../forms'

const Step1 = (props) => {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-relative tw-flex-col lm:tw-flex-row">
      <SearchProject {...props} />
    </div>
  )
}

export default Step1
